"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ASCENDING", {
  enumerable: true,
  get: function get() {
    return _sortingHelper.ASCENDING;
  }
});
Object.defineProperty(exports, "DESCENDING", {
  enumerable: true,
  get: function get() {
    return _sortingHelper.DESCENDING;
  }
});
Object.defineProperty(exports, "renderNoTrending", {
  enumerable: true,
  get: function get() {
    return _Trend.renderNoTrending;
  }
});
Object.defineProperty(exports, "renderTrendingUp", {
  enumerable: true,
  get: function get() {
    return _Trend.renderTrendingUp;
  }
});
Object.defineProperty(exports, "renderTrendingDown", {
  enumerable: true,
  get: function get() {
    return _Trend.renderTrendingDown;
  }
});
exports.DataTable = exports.DataTablePure = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DataTable = require("@cjdev-internal/visual-stack/lib/components/Table/DataTable");

var _reactRedux = require("react-redux");

var _actions = require("../../actions");

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sortingHelper = require("@cjdev-internal/visual-stack/lib/components/Table/DataTable/sortingHelper");

var _Trend = require("@cjdev-internal/visual-stack/lib/components/Table/DataTable/Trend");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DataTablePure =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTablePure, _Component);

  function DataTablePure() {
    _classCallCheck(this, DataTablePure);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataTablePure).apply(this, arguments));
  }

  _createClass(DataTablePure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var initialPayload = R.pick(['id', 'data', 'sortingOption', 'columns'])(this.props);
      this.props.initializeDataTable(initialPayload);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectProps = R.pick(['data', 'sortingOption', 'id']);
      var previousProps = selectProps(prevProps);
      var currentProps = selectProps(this.props);

      if (!R.equals(previousProps.data, currentProps.data)) {
        this.props.setDataTableSortingOption(currentProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sortable = _this$props.sortable,
          columns = _this$props.columns,
          caption = _this$props.caption,
          description = _this$props.description,
          noDataLabel = _this$props.noDataLabel,
          dataTable = _this$props.dataTable,
          pagination = _this$props.pagination,
          id = _this$props.id,
          setDataTablePage = _this$props.setDataTablePage,
          setDataTableSortingOption = _this$props.setDataTableSortingOption,
          setDataTableRows = _this$props.setDataTableRows,
          onClick = _this$props.onClick,
          renderToolbar = _this$props.renderToolbar,
          rowsPerPageTemplate = _this$props.rowsPerPageTemplate,
          totalRecordsTemplate = _this$props.totalRecordsTemplate,
          isLoading = _this$props.isLoading,
          loadingMessage = _this$props.loadingMessage,
          selectable = _this$props.selectable;
      return _react.default.createElement("div", null, _react.default.createElement(_DataTable.DataTable, {
        onClick: onClick,
        caption: caption,
        description: description,
        noDataLabel: noDataLabel,
        sortable: sortable,
        selectable: selectable,
        pagination: pagination,
        data: dataTable.data,
        isLoading: isLoading,
        loadingMessage: loadingMessage,
        columns: columns,
        page: dataTable.pagination.page,
        rowsPerPage: dataTable.pagination.rowsPerPage,
        sortingOption: dataTable.sortingOption,
        onPageChange: function onPageChange(pagination) {
          setDataTablePage({
            id: id,
            pagination: pagination
          });
        },
        onSort: function onSort(_ref) {
          var data = _ref.data,
              sortingOption = _ref.sortingOption;
          setDataTableSortingOption({
            id: id,
            sortingOption: sortingOption
          });
          setDataTableRows({
            id: id,
            data: data
          });
        },
        renderToolbar: renderToolbar,
        rowsPerPageTemplate: rowsPerPageTemplate,
        totalRecordsTemplate: totalRecordsTemplate,
        onSelect: function onSelect(_ref2) {
          var data = _ref2.data;
          setDataTableRows({
            id: id,
            data: data
          });
        }
      }));
    }
  }]);

  return DataTablePure;
}(_react.Component);

exports.DataTablePure = DataTablePure;
DataTablePure.propTypes = {
  caption: _propTypes.default.string,
  description: _propTypes.default.string,
  noDataLabel: _propTypes.default.string,
  sortable: _propTypes.default.bool,
  pagination: _propTypes.default.bool,
  data: _propTypes.default.array,
  columns: _propTypes.default.array,
  dataTable: _propTypes.default.shape({
    data: _propTypes.default.array,
    sortingOption: _propTypes.default.shape({
      label: _propTypes.default.string,
      order: _propTypes.default.string
    }),
    pagination: _propTypes.default.shape({
      page: _propTypes.default.number,
      rowsPerPage: _propTypes.default.number
    })
  }),
  initializeDataTable: _propTypes.default.func.isRequired,
  setDataTablePage: _propTypes.default.func,
  setDataTableSortingOption: _propTypes.default.func,
  onClick: _propTypes.default.func,
  renderToolBar: _propTypes.default.func,
  rowsPerPageTemplate: _propTypes.default.string,
  totalRecordsTemplate: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  loadingMessage: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    dataTable: (0, _actions.selectDataTable)(ownProps.id)(state)
  };
};

var mapDispatchToProps = {
  initializeDataTable: _actions.initializeDataTable,
  setDataTablePage: _actions.setDataTablePage,
  setDataTableSortingOption: _actions.setDataTableSortingOption,
  setDataTableRows: _actions.setDataTableRows
};
var DataTable = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataTablePure);
exports.DataTable = DataTable;